<template>
	<div class="main-layout">
		<div class="main-layout__nav-container">
			<nav ref="navRef" class="main-layout__nav">
				<GlobalLogo></GlobalLogo>
			</nav>
		</div>
		<GlobalBookerFallback nav>
			<ClientOnly>
				<LazyIdleGlobalBooker nav hydrate-on-idle />
			</ClientOnly>
		</GlobalBookerFallback>
		<slot />
		<GlobalCallButton />
		<GlobalSmartAppBanner />
	</div>
</template>

<script setup lang="ts">
const navRef = ref<HTMLElement | null>(null)
const navHeight = ref<number | undefined>(undefined)

onMounted(() => {
	if (navRef.value) {
		const observer = new ResizeObserver((entries) => {
			navHeight.value = entries[0].contentRect.height
		})
		observer.observe(navRef.value)
		onBeforeUnmount(() => observer.disconnect())
	}
})

provide('navHeight', navHeight)
</script>

<style lang="scss" src="./main.scss"></style>
